<template>
  <article class="page article-page">
    <div class="container-fluid container-fluid--to-lg">
      <div v-if="Object.entries(getCurrentPage).length > 0">

        <ImageCarousel :images="getCurrentPage.elements.images.value" v-if="getCurrentPage.elements.images.value.length"/>

        <h1
          v-if="getCurrentPage.elements.title && getCurrentPage.elements.title.value"
          class="article-page__page-title"
        >
          {{ getCurrentPage.elements.title.value }}
        </h1>

        <p
          v-if="getCurrentPage.elements.subtitle.value"
          class="article-page__page-subtitle"
        >{{getCurrentPage.elements.subtitle.value}}</p>

        <div
          v-if="getCurrentPage.elements.cta_text.value && getCurrentPage.elements.cta_url.value"
          class="article-page__cta text-center"
        >
          <a
            class="button button--primary button--cta"
            :href="getCurrentPage.elements.cta_url.value"
            target="_blank"
            rel="noopener"
          >
            {{ getCurrentPage.elements.cta_text.value }}
          </a>
        </div>

        <div
          class="article-page__content"
          v-if="getCurrentPage.elements.content.value && !isContentEmpty(getCurrentPage.elements.content.value)"
          v-html="getCurrentPage.elements.content.value"
        ></div>

        <div
          class="article-page__content-secondary"
          v-if="getCurrentPage.elements.content_secondary.value && !isContentEmpty(getCurrentPage.elements.content_secondary.value)"
          v-html="getCurrentPage.elements.content_secondary.value"
        ></div>
      </div>
      <div v-else-if="loading && Object.entries(getCurrentPage).length === 0" class="text-center">
        <LoaderIcon />
      </div>
      <PageNotFound v-else />
    </div>
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoaderIcon from "@/components/common/LoaderIcon";
import PageNotFound from "@/views/partials/404";
import { setPageTitle, sendPageLoadToGTM } from "@/utils/PageMetaUtil";
import ImageCarousel from "@/components/common/ImageCarousel";
import striptags from "striptags";

export default {
  name: "page",
  components: {
    LoaderIcon,
    PageNotFound,
    ImageCarousel
  },
  computed: {
    ...mapGetters(["getCurrentPage"])
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    ...mapActions(["fetchSinglePage"]),
    isContentEmpty(html) {
      if (!html || typeof html !== "string") return true;
      const text = striptags(html).replace(/&nbsp;|\s|<br\s*\/?>|<hr\s*\/?>/gi, '').trim();
      return text.length === 0;
    }
  },
  mounted() {
    //console.log(this.$route.path);
    let params =  {
      slug: this.$route.path
    };

    if(this.$route.query && this.$route.query.lang) {
      params.language = this.$route.query.lang;
    }

    this.fetchSinglePage(params)
      .then(res => {
        if(Array.isArray(res)) {
          if (res.length) {
            if (res[0] && res[0].elements && res[0].elements.title)
              sendPageLoadToGTM(this.$route, res[0].elements.title.value);

          } else
            sendPageLoadToGTM(this.$route, this.$t("page.404.title"));
        } else if (typeof res === 'object') {
          if (res && res.elements && res.elements.title) {
            console.log("setting document title: ", res.elements.title.value);
            sendPageLoadToGTM(this.$route, res.elements.title.value);
          } else
            sendPageLoadToGTM(this.$route, this.$t("page.404.title"));
        }

        console.log("fetched page, ", res);

        if(!res && !this.getCurrentPage)
          sendPageLoadToGTM(this.$route, this.$t("page.404.title"));

        this.loading = false;
      })
      .catch(err => {
        console.log("Page could not be loaded: ", err);
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/abstracts/_variables.scss" as *;

.article-page {
  &__image {
    padding: 0 0 2.5rem 0;
    margin: 1rem 0 1.5rem 0;
  }
  &__page-title {
    flex: 1 100%;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  &__page-subtitle {
    flex: 1 100%;
    text-align: center;
    margin: 0 0 1rem 0;
  }

  &__content {
    font-size: 0.9rem;
    padding-top: 1rem;
  
    &-secondary {
      padding: 10px;
      font-size: 0.9rem;
      background: $chateauGreyMidLight;

      p {
        color: inherit;
      }
    }
  }

  &__cta {
    display: block;
    text-align: center;
    flex: 1 100%;
    margin-bottom: 1rem;

    button, a {
      background-color: $red;
      border-color: $red;
      text-transform: uppercase;

      &:hover, &:focus {
        background-color: $redDark;
        border-color: $redDark;
      }
    }
  }
}
</style>
